import styled from 'styled-components'

const AboutContainer = styled.div`
  width: 100%;
`

export default AboutContainer
